import { Link } from "react-router-dom";
import { ShieldCheck, Lock, EyeOff, Server, ArrowRight, BellRing } from "lucide-react";

const POINTS = [
  { icon: EyeOff, title: "No account, no tracking of you", desc: "You never create an account, and you can use the calculator and eligibility checker without providing your name, email or contact details." },
  { icon: Lock, title: "Your profile stays in your browser", desc: "Your questionnaire answers are saved only in your own browser's local storage so you can return to them. Clearing your browser data removes them." },
  { icon: Server, title: "Only anonymous data is stored", desc: "When you calculate results we keep an anonymous snapshot of the answers and outcome (age, education, language level, experience, job-offer details, scores) to understand which programs candidates are targeting. It contains no name, phone or IP address. If you click “Share” on a stream report, that report is stored under a random short code and deleted after 90 days." },
  { icon: BellRing, title: "Email only if you volunteer it", desc: "If you choose to leave your email for a follow-up or a draw alert, it is attached to that one result and used solely to contact you about your PNP options or to send a single alert when a stream's cutoff drops to your score. Every alert email carries an unsubscribe link." },
  { icon: ShieldCheck, title: "No sale of data", desc: "We never sell, rent or hand your information to third parties." },
];

export default function Privacy() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700"><ShieldCheck className="h-5 w-5" /></span>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">Privacy</h1>
      </div>

      <p className="mt-6 text-lg leading-relaxed text-slate-600">
        PR Pathfinder is built to be private by default. You can assess your PNP options without giving up any
        identifying information.
      </p>

      <div className="mt-8 space-y-4">
        {POINTS.map((p) => (
          <div key={p.title} className="flex gap-4 rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-slate-900 text-white"><p.icon className="h-5 w-5" /></span>
            <div>
              <h2 className="font-heading font-semibold text-slate-900">{p.title}</h2>
              <p className="mt-1 text-sm leading-relaxed text-slate-600">{p.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-xl border border-slate-200 bg-slate-50 p-6 text-sm leading-relaxed text-slate-600">
        <strong className="text-slate-900">A note on assessment requests.</strong> To compute your scores, your
        profile answers are transmitted securely to our server, processed in memory, and discarded once the result
        is returned. Standard, anonymised web analytics may be used to understand aggregate usage of the site, but
        these are never linked to your immigration profile.
      </div>

      <div className="mt-10 flex justify-center">
        <Link to="/assessment" className="inline-flex items-center gap-2 rounded-md bg-[#C8102E] px-6 py-3 text-sm font-semibold text-white hover:bg-[#A60C24]">
          Start your private assessment <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
